import { useState, useHead } from '#app'
import { watchEffect, onUnmounted } from 'vue'
import type { SchemaEntity } from './types'

export function useSchemaGraph() {
  const namespaces = useState<Record<string, SchemaEntity[]>>('schema:graph', () => ({}))

  function register(namespace: string, entities: SchemaEntity[]) {
    namespaces.value = { ...namespaces.value, [namespace]: entities }
  }

  function registerReactive(namespace: string, entitiesFn: () => SchemaEntity[]) {
    watchEffect(() => {
      namespaces.value = { ...namespaces.value, [namespace]: entitiesFn() }
    })
  }

  function unregister(namespace: string) {
    const { [namespace]: _removed, ...rest } = namespaces.value
    namespaces.value = rest
  }

  function useSchemaHead() {
    useHead(() => ({
      script: [
        {
          key: 'schema-org-graph',
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': Object.values(namespaces.value).flat()
          })
        }
      ]
    }))
  }

  function usePageSchema(entities: SchemaEntity[]) {
    register('page', entities)
    onUnmounted(() => unregister('page'))
  }

  return { namespaces, register, registerReactive, unregister, useSchemaHead, usePageSchema }
}
